import React from "react";

  function MyCard8({ className = "", children ,onClick}) {
  return (
    <div
    onClick={() => onClick && onClick()}
      className={`w-full   ${className} rounded-xl backdrop-blur-sm bg-white dark:bg-slate-800  border border-input border-gray-300/60 dark:border-gray-400/30`}
    >
      {children}
    </div>
  );
}
export default MyCard8;
